import './bootstrap'
import './contact-form'

import { Alpine, Livewire } from '../../vendor/livewire/livewire/dist/livewire.esm'
import initialiseAlpine from './alpine/init'

// Remove no-js class as early as possible to prevent flash of unstyled content
document.documentElement.classList.remove('no-js')

initialiseAlpine(Alpine)

window.Alpine = Alpine
Array.from(document.querySelectorAll('[x-cloak]')).forEach((e) => {
  e.removeAttribute('x-cloak')
})

Livewire.start()
